import { BigNumbersBox } from '../../../../../../components/BigNumbersBox';
import styles from './SummaryCards.module.scss';

type SummaryCardsProps = {
  totalCriados?: number;
  totalDisponiveisNoPlano?: number;
  alertadosUltimos30Dias?: number;
  emAlertaHoje?: number;
  emAlertaHojeFilterActive?: boolean;
  onVisualizarEmAlertaHoje?: () => void;
};

export const SummaryCards = ({
  totalCriados,
  totalDisponiveisNoPlano,
  alertadosUltimos30Dias,
  emAlertaHoje,
  emAlertaHojeFilterActive,
  onVisualizarEmAlertaHoje,
}: SummaryCardsProps) => (
  <div className={styles.wrapper}>
    <div className={styles.box}>
      <BigNumbersBox.MainValue>{totalCriados ?? '-'}</BigNumbersBox.MainValue>
      <p className={styles.cardTitle}>Monitoramentos criados</p>
      {/* "de X monitoramentos disponíveis no seu plano" oculto por enquanto — não há plano nesta
      primeira entrega.
      <BigNumbersBox.RegularText>{`de ${totalDisponiveisNoPlano ?? '-'} monitoramentos disponíveis no seu plano`}</BigNumbersBox.RegularText> */}
    </div>
    <div className={`${styles.box} ${styles.alertBox}`}>
      <BigNumbersBox.MainValue>{alertadosUltimos30Dias ?? '-'}</BigNumbersBox.MainValue>
      <p className={styles.cardTitle}>Alertados nos últimos 30 dias</p>
    </div>
    <div className={`${styles.box} ${styles.alertBox}`}>
      <BigNumbersBox.MainValue>{emAlertaHoje ?? '-'}</BigNumbersBox.MainValue>
      <p className={styles.cardTitle}>Em alerta hoje</p>
      <button type="button" className={styles.visualizarLink} onClick={onVisualizarEmAlertaHoje}>
        {emAlertaHojeFilterActive ? 'Ver todos' : 'Visualizar'}
      </button>
    </div>
  </div>
);
